import { parseISO, addHours } from 'date-fns';
import { createMatchStatus } from '@/transformations/match-status';
import { DEFAULT_LEAD_EXPIRATION_HOURS } from '@/constants';
import addUTCTimeZoneDesignator from '@/utils/add-utc-time-zone-designator';

export function createMatch ({ match = {} }) {
  return {
    ...match,
    time_created: addUTCTimeZoneDesignator(match.time_created),
    time_seen_consumer: addUTCTimeZoneDesignator(match.time_seen_consumer),
    time_seen_pro: addUTCTimeZoneDesignator(match.time_seen_pro),
    time_updated: addUTCTimeZoneDesignator(match.time_updated),
    time_ask_later: addUTCTimeZoneDesignator(match.time_ask_later),
    timeToExpire: addHours(
      parseISO(addUTCTimeZoneDesignator(new Date(match.time_created))),
      DEFAULT_LEAD_EXPIRATION_HOURS
    ).toISOString(),
    status: createMatchStatus(match.status),
    notes: match.notes || [],
  };
}
